import Logo2020 from '../src/Logo2020';
export default Logo2020;
